// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageLayout_container__3Mksm"};